.cover-flag(class=type)
